export function bgslide() {
    const wrapper = document.querySelector(".js-bgslide");
    const slides = [...document.querySelectorAll(".js-bgslide_item")];
    let currentIndex = Math.floor(Math.random() * slides.length);
    const duration = window.getComputedStyle(document.documentElement).getPropertyValue("--bgsDuration");

    if (!wrapper) {
        return;
    }

    const slide = () => {
        slides.forEach((el, index) => {
            el.classList.remove("-active");

            if (index === currentIndex) {
                el.classList.add("-active");
            }
        });

        currentIndex++;
        if (currentIndex > slides.length - 1) {
            currentIndex = 0;
        }
        setTimeout(slide, duration);
    };

    slide();
}
